<app-titlebar #titlebar [titleOptionsClick]="titleOptionsClick" (comReady)="doComReady($event, 'titlebar')"
  style="width: 350px;">
</app-titlebar>
<!-- <div>
  <mat-tab-group class="jk-tab-group" (selectedTabChange)="onTabChange($event)">
    @for (tab of masterSrv.mtrWd015List; track tab) {
    <mat-tab [label]="tab.name"></mat-tab>
    }
  </mat-tab-group>
</div>
 -->
<mat-toolbar class="flex h-20 jk-border background-color-light-blue align-items-column" style="width: 350px;">
  <app-jkcombobox class="jk-combobox-border " [styleDisplay]="'flex'" labelMode="floating" label="" valueExpr="id"
    displayExpr="name" [(value)]="srv.wd015" [required]="false" [showClearButton]="true" [required]="true"
    (valueChange)="wd015Change($event)" [items]="srv.mtrWd015List" (comReady)="doComReady($event, 'wd015')">
  </app-jkcombobox>
  <mat-form-field>
    <mat-label>篩選</mat-label>
    <input matInput (keyup)="tableSrv.applyFilter($event)" #input>
  </mat-form-field>
  <button [matBadge]="srv.itemList().length" [matBadgeColor]="'warn'" class="btn btn-primary"
    (click)="doRefresh()">重新整理</button>
  <label color="danger" class="text-left leading-tight">筆數</label>
  <button class="btn btn-primary" (click)="doInsertMobile()">
    <mat-icon fontIcon="add"></mat-icon>新增
  </button>
  <button class="btn btn-primary" (click)="doQuickInsert()">
    速記
  </button>

</mat-toolbar>
<mat-divider></mat-divider>
<table mat-table [dataSource]="tableSrv.tableDataSource" matSort>
  <!-- Name Column -->
  <ng-container matColumnDef="WD001">
    <th mat-header-cell *matHeaderCellDef> * </th>
    <td mat-cell *matCellDef="let item" style="height: 12px;">
      <mat-toolbar class="h-20">
        <app-jkdatefield labelMode="floating" label="日期" [(value)]="item.WD002" [showClearButton]="false">
        </app-jkdatefield>
        <!-- 日期:{{dateField2Display(item.WD002)}},
        預計日期:{{dateField2Display(item.WD002)}}-->
        <button class="btn btn-primary" [matBadge]="item.CNT" (click)="showDetail(item)">明細</button>
        <button class="btn btn-info" (click)="doEditAndSave(item)">存檔</button>
        <button class="btn btn-warning" (click)="doFinish(item)">結案</button>
        <button class="btn btn-info" (click)="doEditMobile()">
          <mat-icon fontIcon="edit"></mat-icon>編輯
        </button>
      </mat-toolbar>
      <mat-toolbar>
        <div class="ai-star-center">
          <app-jkstarmark [value]="item.WD027" [isUpdate]="false" (onClick)="srv.toggleStar(item,true)">
          </app-jkstarmark>
        </div>
        <app-jkedit [label]="''" style="font-size: larger;color: blue; width: 600px;" [styleDisplay]="'flex'"
          [(value)]="item.WD004" [required]="true">
        </app-jkedit>
        <app-jkcombobox label="" #WD015Com id="WD015" [(value)]="item.WD015" [items]="srv.mtrWd015List"
          [readonly]="isBrowse">
        </app-jkcombobox>
      </mat-toolbar>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@2.0.0-rc.5/dist/quill.bubble.css" />
      <div class="jk-component-border" matTooltip="html編輯,區域選擇出現功能表">
        <quill-editor #htmleditor class="w-full" [ngModel]="text2Html(item.WD003)" [theme]="'bubble'"
          [modules]="quillEditorOptions" (onContentChanged)="quillEditorReady($event)"></quill-editor>
      </div>
    </td>
  </ng-container>
  <tr mat-row (click)="tableSrv.tableRowClick(row)" *matRowDef="let row; columns: tableSrv.displayedColumns;"></tr>
</table>
<mat-paginator #paginator [pageSizeOptions]="[10, 100, 1000]" aria-label="Select page of users"
  (ready)="doComReady($event, 'paginator')">
</mat-paginator>